"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConcernForm = exports.concernFormContext = exports.Provider = exports.ConcernFormProvider = void 0;
var _react = require("react");
var _utils = require("../utils");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- context */ const defaultConcernFormContextValues = {
    editable: true,
    isServerError: false,
    isFormSent: false,
    setIsServerError: ()=>{},
    setIsFormSent: ()=>{},
    setEditable: ()=>{},
    setSentValues: ()=>{},
    concernFormConfig: {
        characterLimitForATextArea: 0,
        characterLimitForATextField: 0,
        enabled: false,
        recaptchaEnabled: false,
        enabledPdfDownload: true,
        siteKey: ''
    },
    concernFormData: {
        introduction: '',
        introductionTitle: '',
        questionRequired: '',
        questions: [],
        radioButtonNo: '',
        radioButtonYes: '',
        required: '',
        sendButton: '',
        tooManyCharactersMaximumIs: ''
    }
};
const concernFormContext = exports.concernFormContext = /*#__PURE__*/ (0, _react.createContext)(defaultConcernFormContextValues);
const { Provider } = concernFormContext;
exports.Provider = Provider;
const ConcernFormProvider = (param)=>{
    let { children, formConfig, formData } = param;
    const [isServerError, setIsServerError] = (0, _react.useState)(false);
    const [isFormSent, setIsFormSent] = (0, _react.useState)(false);
    const [editable, setEditable] = (0, _react.useState)(true);
    const [sentValues, setSentValues] = (0, _react.useState)();
    const value = (0, _react.useMemo)(()=>({
            editable,
            isServerError,
            isFormSent,
            setIsServerError,
            setIsFormSent,
            sentValues,
            setSentValues,
            setEditable,
            concernFormConfig: (0, _utils.mapToConcernFormConfig)(formConfig),
            concernFormData: (0, _utils.mapToConcernFormData)(formData)
        }), [
        editable,
        isServerError,
        isFormSent,
        sentValues,
        formConfig,
        formData
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
        value: value,
        children: children
    });
};
exports.ConcernFormProvider = ConcernFormProvider;
const useConcernForm = ()=>(0, _react.useContext)(concernFormContext);
exports.useConcernForm = useConcernForm;
